module.exports = __webpack_public_path__ + "img/Dantam Makeover 30.a799e294.jpg";